package com.shadowings.gero.data.lessons.chapter5

import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_alyn
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_alyn_2
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_1
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_2
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_3
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_4
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_5
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_6
import gero.composeapp.generated.resources.exp_content_verbi_intro_1_nilo_7
import gero.composeapp.generated.resources.exp_title_verbi_intro_1
import gero.composeapp.generated.resources.quiz_verbi_intro_1_1
import gero.composeapp.generated.resources.quiz_verbi_intro_1_2
import gero.composeapp.generated.resources.quiz_verbi_intro_1_3
import gero.composeapp.generated.resources.quiz_verbi_intro_1_4
import gero.composeapp.generated.resources.quiz_verbi_intro_1_5
import gero.composeapp.generated.resources.quiz_verbi_intro_1_6

fun getVerbiIntro1Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_alyn,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_1,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_2,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_3,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_4,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_5,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_alyn_2,
            face = Faces.Surprised,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_6,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_verbi_intro_1,
            content = Res.string.exp_content_verbi_intro_1_nilo_7,
            face = Faces.Sad,
            character = Characters.Nilo,
        ),
    )
}

fun getVerbiIntro1QuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_1,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_3,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_4,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_5,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_verbi_intro_1_6,
            correct = false
        ),
    )
}
